/* eslint-disable prettier/prettier */
import axios from "axios";
import { DayMonthYearFormatOnly } from "../../helpers/momentFormat";

const state = {
  billings: {},
  billingPayment: {},
  isLoadingTable: false,
  showDeleteModal: false,
  showAddEditBillingModal: false
};

const mutations = {
  getPaginatedData(state, payload) {
    state.isLoadingTable = true;
    axios
      .get(
        `api/billings/page=${payload.page}&pageSize=${payload.pageSize}/${
          payload.query
        }`
      )
      .then(response => {
        response.data.data.forEach(d => {
          d.dateCreated = DayMonthYearFormatOnly(d.dateCreated);
          if (d.siDate) d.siDate = DayMonthYearFormatOnly(d.siDate);
          if (d.drDate) d.drDate = DayMonthYearFormatOnly(d.drDate);
        });
        state.billings = response.data;
        // eslint-disable-next-line no-console
      })
      .catch(error => console.log(error))
      .then(() => (state.isLoadingTable = false));
  },
  openDeleteModal(state, payload) {
    state.showDeleteModal = payload.showDeleteModal;
    if (payload.billingPayment) {
      state.billingPayment = payload.billingPayment;
    } else {
      state.billingPayment = {};
    }
  },
  openAddEditBillingModal(state, payload) {
    state.showAddEditBillingModal = payload.showAddEditBillingModal;
    if (payload.billingPayment) {
      state.billingPayment = payload.billingPayment;
    } else {
      state.billingPayment = {};
    }
  }
};

const actions = {
  getPaginatedData({ commit }, payload) {
    commit("getPaginatedData", payload);
  },
  openDeleteModal({ commit }, payload) {
    commit("openDeleteModal", payload);
  },
  openAddEditBillingModal({ commit }, payload) {
    commit("openAddEditBillingModal", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
